import { Component, OnInit } from '@angular/core';
import { DevExtremeModule } from 'devextreme-angular';
import moment from 'moment';
import { AppInformationService, AuthService, CdrUnitOfWork, UtilityService } from 'src/app/core/core.module';
import { DumpsterLocation } from 'src/app/core/model/dumpster-location';
import { Job } from 'src/app/core/model/job';
import { JobType } from 'src/app/core/model/job-type';
import { Rental } from 'src/app/core/model/rental';
import { StorageDumpSite } from 'src/app/core/model/storage-dump-site';
import { ServiceAddressDialogComponent } from 'src/app/customer/service-address-dialog/service-address-dialog.component';
import { AuditDialogComponent } from 'src/app/shared/audit-dialog/audit-dialog.component';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';
import { DialogService } from 'src/app/shared/dialog.service';
import { InputDialogComponent } from 'src/app/shared/input-dialog/input-dialog.component';
import { alert, confirm } from 'src/app/shared/shared.module';

@Component({
    selector: 'app-job-time-dialog',
    templateUrl: './job-time-dialog.component.html',
    styleUrls: ['./job-time-dialog.component.scss'],
    imports: [DevExtremeModule]
})
export class JobTimeDialogComponent extends BaseDialogComponent<any> implements OnInit {
    jobId: number;
    jobTimes: any[];

    constructor(
        private uow: CdrUnitOfWork,
        private dialogService: DialogService,
        private authService: AuthService,
        private appInfo: AppInformationService,
        private utilityService: UtilityService
    ) {
        super();
    }

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.jobTimes = await this.uow.getJobTimesByJobId(this.jobId);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            }
        );
    }

    async editStart(selectedRow?: any) {
        if (!selectedRow) return;
        const dialogRef = this.dialogService.open(InputDialogComponent);
        dialogRef.instance.dialogHeader = 'Edit Start Time';
        dialogRef.instance.mode = 'datetime';
        dialogRef.instance.dialogValue = selectedRow.started;
        const result = await dialogRef.instance.show();
        this.dialogService.close(dialogRef);

        if (result.success && result.value) {
            this.appInfo.pleaseWaitShow();
            selectedRow.started = result.value;
            await this.uow.commit([selectedRow]);
            await this.utilityService.updateTotalMinutes(selectedRow.id);
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
    }

    async editCompleted(selectedRow?: any) {
        if (!selectedRow) return;
        const dialogRef = this.dialogService.open(InputDialogComponent);
        dialogRef.instance.dialogHeader = 'Edit Completed Time';
        dialogRef.instance.mode = 'datetime';
        dialogRef.instance.dialogValue = selectedRow.completed;
        const result = await dialogRef.instance.show();
        this.dialogService.close(dialogRef);

        if (result.success && result.value) {
            this.appInfo.pleaseWaitShow();
            selectedRow.completed = result.value;
            await this.uow.commit([selectedRow]);
            await this.utilityService.updateTotalMinutes(selectedRow.id);
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
    }

    async deleteTime(selectedRow?: any) {
        if (!selectedRow) return;
        const success = await confirm(`Are you sure you want to DELETE this time entry?`, this.appInfo.company);
        if (!success) return;

        this.appInfo.pleaseWaitShow();
        selectedRow.deleted = new Date();
        selectedRow.deletedBy = this.authService.userValue.userName;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
